module.exports = __webpack_public_path__ + "static/media/AnonymousServer_cover.095f8a02.png";